import z from "zod";
import { PageableRequestSchema } from "./shared";

export const GetJobsRequestSchema = z.object({
  companyId: z.number(),
  machineId: z.number(),
  pageable: PageableRequestSchema,
});

export type GetJobsRequest = z.infer<typeof GetJobsRequestSchema>;

export const JobStatusSchema = z.enum([
  "PENDING",
  "PENDING_HELD",
  "PROCESSING",
  "PROCESSING_STOPPED",
  "CANCELED",
  "ABORTED",
  "COMPLETED",
]);

export type JobStatus = z.infer<typeof JobStatusSchema>;

export const GetJobsResponseSchema = z.object({
  id: z.number(),
  index: z.number(),
  machineId: z.number(),
  jobName: z.string().nullable().optional(),
  startTime: z.string(),
  completeTime: z.string().nullable().optional(),
  status: JobStatusSchema
});

export type GetJobsResponse = z.infer<typeof GetJobsResponseSchema>;